import { memo, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Checkbox, Radio, RadioGroup } from 'basic-components';
import TimeService from 'dashboard-services/services/TimeService';

const DAILY = {
  DAY_OF_WEEK: "DAY_OF_WEEK",
  DAY_OF_MONTH: "DAY_OF_MONTH",
  EVERYDAY: "EVERYDAY",
}
const getSelectedDaily = (dayOfWeek, dayOfMonth) => {
  if(dayOfMonth === "*" || dayOfWeek === "*") {
    return DAILY.EVERYDAY;
  }
  if(dayOfMonth === "" || dayOfMonth === "?") {
    return DAILY.DAY_OF_WEEK;
  }
  if(dayOfMonth.split(",").length === 31 && dayOfWeek !== "?") {
    return DAILY.DAY_OF_WEEK;
  }
  return DAILY.DAY_OF_MONTH;
}

const Day = ({ dayOfMonth = "", dayOfWeek = "", setDayOfMonth, setDayOfWeek }) => {
  const [selectedDaily, setSelectedDaily] = useState(() => getSelectedDaily(dayOfWeek, dayOfMonth)),
        onChangeExactDayOfWeek = useCallback(selected => {
          const splittedDay = dayOfWeek === "*" || dayOfWeek === "?" || dayOfWeek === "" ? [] : String(dayOfWeek).split(",")
          if(splittedDay.indexOf(String(selected)) > -1) {
            setDayOfWeek(splittedDay.remove(splittedDay.indexOf(String(selected))).join(","))
            setDayOfMonth("?")
          } else {
            setDayOfWeek(splittedDay.add(selected).join(","))
            setDayOfMonth("?")
          }
        }, [dayOfWeek, setDayOfWeek, setDayOfMonth]),
        onChangeExactDayOfMonth = useCallback(selected => {
          const splittedDay = dayOfMonth === "*" || dayOfMonth === "?" || dayOfMonth === "" ? [] : String(dayOfMonth).split(",")
          if(splittedDay.indexOf(String(selected)) > -1) {
            setDayOfMonth(splittedDay.remove(splittedDay.indexOf(String(selected))).join(","))
            setDayOfWeek("?")
          } else {
            setDayOfMonth(splittedDay.add(selected).join(","))
            setDayOfWeek("?")
          }
        }, [dayOfMonth, setDayOfMonth, setDayOfWeek]),
        onChangeSelectedDaily = useCallback(value => value && setSelectedDaily(value), []),
        onClickEveryday = useCallback(() => {
          setDayOfMonth("*")
          setDayOfWeek("?")
        }, [setDayOfMonth, setDayOfWeek])

  useEffect(() => {
    setSelectedDaily(getSelectedDaily(dayOfWeek, dayOfMonth))
  }, [dayOfMonth, dayOfWeek])

  return (
    <div className="cron-creator__body__day">
      <RadioGroup
          name="daily"
          onChange={onChangeSelectedDaily}
          selectedValue={selectedDaily}
      >
        <Radio name={DAILY.DAY_OF_WEEK}>
          Day of week
        </Radio>
        <div className="cron-creator__body__at">
          {[...Array(7).keys()].map(index => (
            <Checkbox
                checked={String(dayOfWeek).split(",").includes(String(index)) && dayOfWeek !== "*"}
                key={index}
                onChange={() => onChangeExactDayOfWeek(index)}
            >
              {TimeService.getWeekDay(index)}
            </Checkbox>
          ))}
        </div>
        <Radio name={DAILY.DAY_OF_MONTH}>
          Day of month
        </Radio>
        <div className="cron-creator__body__at">
          {[...Array(31).keys()].map(index => (
            <Checkbox
                checked={String(dayOfMonth).split(",").includes(String(index + 1)) && dayOfMonth !== "*"}
                key={index}
                onChange={() => onChangeExactDayOfMonth(index + 1)}
            >
              {('0' + String(index + 1)).slice(-2)}
            </Checkbox>
          ))}
        </div>
        <Radio 
            name={DAILY.EVERYDAY}
            onClick={onClickEveryday}
        >
          Every day
        </Radio>
      </RadioGroup>
    </div>
  )
}

Day.propTypes = {
  dayOfMonth: PropTypes.string,
  dayOfWeek: PropTypes.string,
  setDayOfMonth: PropTypes.func.isRequired,
  setDayOfWeek: PropTypes.func.isRequired
}

export default memo(Day);